import { apiClient } from "@/services/apiClient";

export type PartnerDiscountType = "flat" | "percent";
export type PartnerStatus = "active" | "paused";

export interface PartnerDiscountStage {
  discountType: PartnerDiscountType;
  discountValue: number;
  durationMonths: number;
}

export interface Partner {
  id: string;
  name: string;
  slug: string;
  code: string;
  stages: PartnerDiscountStage[];
  /** Plan ids this benefit applies to. Null = any plan. */
  applicablePlanIds: string[] | null;
  usageCap: number | null;
  status: PartnerStatus;
  notes: string | null;
  createdAt: string;
  updatedAt: string;
  redemptionCount: number;
  /** Sum of paid partner_payment_link_charge rows, minor units (UYU). */
  collectedMinor: number;
  /** Charges awaiting payment right now. */
  pendingChargeCount: number;
}

export interface CreatePartnerPayload {
  name: string;
  code: string;
  stages: PartnerDiscountStage[];
  applicablePlanIds?: string[] | null;
  usageCap?: number | null;
  notes?: string | null;
}

export type UpdatePartnerPayload = Partial<CreatePartnerPayload> & {
  status?: PartnerStatus;
};

export function listPartners(): Promise<Partner[]> {
  return apiClient
    .get<Partner[]>("/platform/partners")
    .then((res) => res.data);
}

export function createPartner(payload: CreatePartnerPayload): Promise<Partner> {
  return apiClient
    .post<Partner>("/platform/partners", payload)
    .then((res) => res.data);
}

export function updatePartner(
  id: string,
  payload: UpdatePartnerPayload,
): Promise<Partner> {
  return apiClient
    .patch<Partner>(`/platform/partners/${id}`, payload)
    .then((res) => res.data);
}
